import { useNavigate } from '@tanstack/react-router'

import { SHIPMENT_STAGES } from '../model/stages'
import type { ShipmentStage } from '../model/stages'
import {
  ORDER_DISPATCH_ROUTE,
  STAGE_CONVERT_ROUTE,
  STAGE_EDIT_ROUTE,
} from './stage-route'
import type { StageRoute } from './stage-route'

export function useShipmentSidebarActions(
  stage: ShipmentStage,
  shipmentId: string,
) {
  const navigate = useNavigate()
  const go = (route: StageRoute) =>
    void navigate({
      to: route.to as never,
      params: { [route.paramKey]: shipmentId } as never,
    })

  const convertRoute = STAGE_CONVERT_ROUTE[stage]
  return {
    onEdit: () => go(STAGE_EDIT_ROUTE[stage]),
    onConvert: convertRoute ? () => go(convertRoute) : undefined,
    onDispatch:
      stage === SHIPMENT_STAGES.ORDER
        ? () => go(ORDER_DISPATCH_ROUTE)
        : undefined,
  }
}
